var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-simple-header",
    _vm._b(
      {
        attrs: {
          "left-part-size": _vm.leftPartSize,
          "right-part-size": _vm.rightPartSize,
          "separation-mode": "md",
          "with-background": false,
        },
      },
      "vue-simple-header",
      _vm.$attrs,
      false
    ),
    [
      _c("span", { attrs: { slot: "headerTitle" }, slot: "headerTitle" }, [
        _c("span", { staticClass: "group-page-header" }, [
          _vm._v(_vm._s(_vm.title || _vm.group.name)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "panelRight" }, slot: "panelRight" },
        [
          _vm._t("additionalButtons"),
          _vm._v(" "),
          _vm.viewer_state.can_invite
            ? _c("vue-folder-button", {
                attrs: {
                  tabindex: "0",
                  "aria-label": "Invite Users",
                  "icon-class": "fa-user-plus",
                  text: "Invite Users",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.inviteUsers.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("vue-folder-button", {
            attrs: {
              target: _vm.backUrl,
              "icon-class": "fa-reply",
              color: "blue",
              text: "Back",
              "no-text-on-mobile": "",
            },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }